import { render, staticRenderFns } from "./edit-ceping2.vue?vue&type=template&id=47b770fe&scoped=true"
import script from "./edit-ceping2.vue?vue&type=script&lang=ts"
export * from "./edit-ceping2.vue?vue&type=script&lang=ts"
import style0 from "./edit-ceping2.vue?vue&type=style&index=0&id=47b770fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b770fe",
  null
  
)

export default component.exports